import React from "react";

export default function FolderUserIcon(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.6801 9.98322C18.7009 10.114 18.7205 10.245 18.7389 10.3761C18.7564 10.501 18.8493 10.6014 18.9705 10.6363C19.3283 10.7393 19.6626 10.8979 19.9634 11.1021C20.1139 11.2043 20.3348 11.0911 20.3156 10.9102C20.2745 10.5215 20.223 10.1335 20.1613 9.74679L20.0972 9.34535C19.8913 8.05533 18.7786 7.10612 17.4722 7.10612L9.1578 7.10612C8.95229 6.04846 8.02102 5.25 6.90327 5.25H4.6117C3.25541 5.25 2.11301 6.26343 1.9513 7.61004L1.67882 9.87915C1.38916 12.2913 1.46392 14.7333 1.90058 17.1232C2.1161 18.3027 3.10261 19.1869 4.29864 19.2725L5.81264 19.3808C7.99337 19.5368 10.1794 19.5943 12.364 19.5533C12.5028 19.5507 12.6204 19.4524 12.6568 19.3183C12.748 18.9821 12.8773 18.6615 13.0397 18.3615C13.1168 18.219 13.0142 18.0378 12.8522 18.042C10.5408 18.1022 8.22723 18.0497 5.91968 17.8846L4.40568 17.7763C3.8922 17.7396 3.46868 17.36 3.37615 16.8536C2.96652 14.6116 2.89639 12.3208 3.16812 10.058L3.4406 7.78888C3.51179 7.19611 4.01467 6.75 4.6117 6.75H6.90327C7.34331 6.75 7.70003 7.10672 7.70003 7.54677C7.70003 8.13183 8.17432 8.60612 8.75939 8.60612H17.4722C18.0414 8.60612 18.5263 9.0197 18.616 9.58178L18.6801 9.98322Z"
        fill="#A6B0CF"
      />
      <path
        d="M18 12C16.8955 12 16 12.8954 16 14C16 15.1046 16.8955 16 18 16C19.1046 16 20 15.1046 20 14C20 12.8954 19.1046 12 18 12Z"
        fill="#A6B0CF"
      />
      <path
        d="M14 20.5C14 18.8431 15.3432 17.5 17 17.5H19C20.6569 17.5 22 18.8431 22 20.5C22 21.0523 21.5523 21.5 21 21.5H15C14.4477 21.5 14 21.0523 14 20.5Z"
        fill="#A6B0CF"
      />
    </svg>
  );
}
